import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { QuickUserInfoService } from 'app/shared/quick-user-info/quick-user-info.service';

@Component({
  selector: 'pcg-resizable-widget',
  imports: [],
  templateUrl: './resizable-widget.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './resizable-widget.component.scss',
})
export class ResizableWidgetComponent {
    infoService = inject(QuickUserInfoService);

    readonly showFacility = input<boolean>(false);
}
